import { create } from "zustand";
import axiosInstance from "../api/axiosInstance";
import useAuthStore from "./useAuthStore";
import { useRegisterQuestionsStore } from "./useRegisterQuestionsStore";

interface SearchProfileState {
  filters: {
    lat: string;
    lng: string;
    gender: number[];
    relationshipIntent: number[];
    minAge: number | null;
    maxAge: number | null;
    location: number; // miles
    ethnicity: string | number;
    education: string | number;
    religion: string | number;
    maritalStatus: number[];
    politicalAffiliation: number[];
    minHeight: string;
    maxHeight: string;
    bodyType: number[];
    smoker: number[];
    alcohol: number[];
    marijuanaFriendly: number[];
  };
  profiles: any[];
  loading: boolean;
  page: number;
  totalPages: number;
  setFilter: (key: keyof SearchProfileState["filters"], value: any) => void;
  resetFilters: () => void;
  fetchProfiles: () => Promise<void>;
  setPage: (page: number) => void;
  initFilters: () => void;
}


const authStore = useAuthStore.getState();


export const useSearchProfileStore = create<SearchProfileState>((set, get) => ({



  filters: {
    lat: authStore.user?.lat || 0,
    lng: authStore.user?.lang || 0,
    gender: [],
    relationshipIntent: [],
    minAge: authStore.user?.looking_min_age,
    maxAge: authStore.user?.looking_max_age,
    location: 500, // Default miles
    ethnicity: "",
    education: "",
    religion: "",
    maritalStatus: [],
    politicalAffiliation: [],
    minHeight: "",
    maxHeight: "",
    bodyType: [],
    smoker: [],
    alcohol: [],
    marijuanaFriendly: [],
  },
  profiles: [],
  loading: false,
  page: 1,
  totalPages: 1,

  setFilter: (key, value) => {
    console.log('setFilter', value);

    set((state) => ({
      filters: { ...state.filters, [key]: value },
    }));
  },

  resetFilters: () => {
    const authStore = useAuthStore.getState();
    set({
      filters: {
        lat: authStore.user?.lat || 0,
        lng: authStore.user?.lang || 0,
        gender: [],
        relationshipIntent: [],
        minAge: 18,
        maxAge: 60,
        location: 500,
        ethnicity: "",
        education: "",
        religion: "",
        maritalStatus: [],
        politicalAffiliation: [],
        minHeight: "",
        maxHeight: "",
        bodyType: [],
        smoker: [],
        alcohol: [],
        marijuanaFriendly: [],
      },
      page: 1, // Reset to first page

    });
    get().fetchProfiles();
  },

  setPage: (page) => {
    set({ page });
    get().fetchProfiles(); // Fetch new page data
  },

  // Add a new method to initialize filters after data loads
  initFilters: async () => {
    console.log('intialiazation................');
    const genderId = await useRegisterQuestionsStore.getState().getUserAnswerByTitle('Seeking');
    // const relationshipId = await useRegisterQuestionsStore.getState().getUserAnswerByTitle('Looking_Relationship');
    // const ethnicityId = await useRegisterQuestionsStore.getState().getUserAnswerByTitle('Ethnicity');
    // const educationId = await useRegisterQuestionsStore.getState().getUserAnswerByTitle('Education');

    console.log('intialiazation................', genderId);
    // console.log('intialiazation................',relationshipId);
    // console.log('intialiazation................',ethnicityId);
    const authStore = useAuthStore.getState();
    set((state) => ({
      filters: {
        ...state.filters,
        lat: authStore.user?.lat || 0,
        lng: authStore.user?.lang || 0,
        gender: genderId == 116 ? [93] : [92],
        // relationshipIntent: relationshipId ? [relationshipId] : [],
        minAge: 18,
        maxAge: 60,
        location: 500,

      },
      page: 1,
    }));
    get().fetchProfiles();
  },
  fetchProfiles: async () => {
    const { filters, page } = get();
    set({ loading: true });

    try {
      const authStore = useAuthStore.getState();
      const user = authStore.user;
      const sanitizedFilters = {
        ...filters,
        lat: Number(filters.lat) || 0,
        lng: Number(filters.lng) || 0
      };
      const response = await axiosInstance.post("searchProfile", { ...sanitizedFilters, page, id: user.id });
      set({
        profiles: response.data.users,
        totalPages: Math.ceil(response.data.totalResults / 10),
        page: page,
        loading: false
      });
    } catch (error) {
      console.error("Error fetching profiles:", error);
      set({ loading: false });
    }
  },


}));
